import { defineMessages } from 'react-intl';

import { WorkflowOperatorType } from '~/enums/WorkflowOperatorType';

const {
  AllOfTheseWords,
  AnyOfTheseWords,
  Between,
  Contains,
  ContainsAll,
  ContainsAnyOf,
  DoesNotContain,
  ExactPhrase,
  Equal,
  GreaterThan,
  GreaterThanEqual,
  IsBlank,
  IsNotBlank,
  LessThan,
  LessThanEqual,
  NotEqual,
} = WorkflowOperatorType;

const messages = defineMessages({
  allOfTheseWords: {
    id: 'OperatorDefinitions.allOfTheseWords',
    defaultMessage: 'All of these words',
    description: 'Operator label for all of these words condition',
  },
  anyOfTheseWords: {
    id: 'OperatorDefinitions.anyOfTheseWords',
    defaultMessage: 'Any of these words',
    description: 'Operator label for any of these words condition',
  },
  between: {
    id: 'OperatorDefinitions.between',
    defaultMessage: 'Between',
    description: 'Operator label for between condition',
  },
  contains: {
    id: 'OperatorDefinitions.contains',
    defaultMessage: 'Contains',
    description: 'Operator label for contains condition',
  },
  containsAll: {
    id: 'OperatorDefinitions.containsAll',
    defaultMessage: 'Contains all',
    description: 'Operator label for contains all condition',
  },
  containsAnyOf: {
    id: 'OperatorDefinitions.containsAnyOf',
    defaultMessage: 'Contains any of',
    description: 'Operator label for contains any of condition',
  },
  doesNotContain: {
    id: 'OperatorDefinitions.doesNotContain',
    defaultMessage: 'Does not contain',
    description: 'Operator label for does not contain condition',
  },
  exactPhrase: {
    id: 'OperatorDefinitions.exactPhrase',
    defaultMessage: 'Exact phrase',
    description: 'Operator label for exact phrase condition',
  },
  equals: {
    id: 'OperatorDefinitions.equals',
    defaultMessage: 'Equals',
    description: 'Operator label for equals condition',
  },
  greaterThan: {
    id: 'OperatorDefinitions.greaterThan',
    defaultMessage: 'Greater than',
    description: 'Operator label for greater than condition',
  },
  greaterThanEqual: {
    id: 'OperatorDefinitions.greaterThanEqual',
    defaultMessage: 'Greater than or equal to',
    description: 'Operator label for greater than or equal to condition',
  },
  isBlank: {
    id: 'OperatorDefinitions.isBlank',
    defaultMessage: 'Is blank',
    description: 'Operator label for is blank condition',
  },
  isNotBlank: {
    id: 'OperatorDefinitions.isNotBlank',
    defaultMessage: 'Is not blank',
    description: 'Operator label for is not blank condition',
  },
  lessThan: {
    id: 'OperatorDefinitions.lessThan',
    defaultMessage: 'Less than',
    description: 'Operator label for less than condition',
  },
  lessThanEqual: {
    id: 'OperatorDefinitions.lessThanEqual',
    defaultMessage: 'Less than or equal to',
    description: 'Operator label for less than or equal to condition',
  },
  doesNotEqual: {
    id: 'OperatorDefinitions.doesNotEqual',
    defaultMessage: 'Does not equal',
    description: 'Operator label for does not equal condition',
  },
});

// Duplicate list with only cardinality and no label or values
export const operatorCardinalities = {
  [AllOfTheseWords]: 1,
  [AnyOfTheseWords]: 1,
  [Between]: 2,
  [Contains]: 1,
  [ContainsAll]: Infinity,
  [ContainsAnyOf]: Infinity,
  [DoesNotContain]: 1,
  [ExactPhrase]: 1,
  [Equal]: 1,
  [GreaterThan]: 1,
  [GreaterThanEqual]: 1,
  [IsBlank]: 0,
  [IsNotBlank]: 0,
  [LessThan]: 1,
  [LessThanEqual]: 1,
  [NotEqual]: 1,
};

export default function getOperatorDefinitions(intl) {
  return {
    [AllOfTheseWords]: {
      label: intl.formatMessage(messages.allOfTheseWords),
      value: AllOfTheseWords,
      valueCardinality: operatorCardinalities[AllOfTheseWords],
    },
    [AnyOfTheseWords]: {
      label: intl.formatMessage(messages.anyOfTheseWords),
      value: AnyOfTheseWords,
      valueCardinality: operatorCardinalities[AnyOfTheseWords],
    },
    [Between]: {
      label: intl.formatMessage(messages.between),
      value: Between,
      valueCardinality: operatorCardinalities[Between],
    },
    [Contains]: {
      label: intl.formatMessage(messages.contains),
      value: Contains,
      valueCardinality: operatorCardinalities[Contains],
    },
    [ContainsAll]: {
      label: intl.formatMessage(messages.containsAll),
      value: ContainsAll,
      valueCardinality: operatorCardinalities[ContainsAll],
    },
    [ContainsAnyOf]: {
      label: intl.formatMessage(messages.containsAnyOf),
      value: ContainsAnyOf,
      valueCardinality: operatorCardinalities[ContainsAnyOf],
    },
    [DoesNotContain]: {
      label: intl.formatMessage(messages.doesNotContain),
      value: DoesNotContain,
      valueCardinality: operatorCardinalities[DoesNotContain],
    },
    [ExactPhrase]: {
      label: intl.formatMessage(messages.exactPhrase),
      value: ExactPhrase,
      valueCardinality: operatorCardinalities[ExactPhrase],
    },
    [Equal]: {
      label: intl.formatMessage(messages.equals),
      value: Equal,
      valueCardinality: operatorCardinalities[Equal],
    },
    [GreaterThan]: {
      label: intl.formatMessage(messages.greaterThan),
      value: GreaterThan,
      valueCardinality: operatorCardinalities[GreaterThan],
    },
    [GreaterThanEqual]: {
      label: intl.formatMessage(messages.greaterThanEqual),
      value: GreaterThanEqual,
      valueCardinality: operatorCardinalities[GreaterThanEqual],
    },
    [IsBlank]: {
      label: intl.formatMessage(messages.isBlank),
      value: IsBlank,
      valueCardinality: operatorCardinalities[IsBlank],
    },
    [IsNotBlank]: {
      label: intl.formatMessage(messages.isNotBlank),
      value: IsNotBlank,
      valueCardinality: operatorCardinalities[IsNotBlank],
    },
    [LessThan]: {
      label: intl.formatMessage(messages.lessThan),
      value: LessThan,
      valueCardinality: operatorCardinalities[LessThan],
    },
    [LessThanEqual]: {
      label: intl.formatMessage(messages.lessThanEqual),
      value: LessThanEqual,
      valueCardinality: operatorCardinalities[LessThanEqual],
    },
    [NotEqual]: {
      label: intl.formatMessage(messages.doesNotEqual),
      value: NotEqual,
      valueCardinality: operatorCardinalities[NotEqual],
    },
  };
}
